import { RetweetOutlined } from '@ant-design/icons';
import { App, Button } from 'antd';
import { useTranslation } from 'react-i18next';

import {
  INTERVIEW_ID_PARAM,
  STAGE_PARAM,
  SHOW_DATE_PROPOSE_PARAM,
  RESCHEDULE_PARAM,
} from '@/constants/queryParams';
import { CANDIDATES } from '@/constants/routes';
import { confirmDialog } from '@/UI/confirmDialog';

import type { LegacyHistory as History } from '@/hooks/useUrlState';
import type { InterviewRoom } from '@/types/interview';

interface RescheduleButtonProps {
  interview: InterviewRoom;
  history: History;
}

const RescheduleDate = ({ interview, history }: RescheduleButtonProps) => {
  const [t] = useTranslation();
  const { modal } = App.useApp();
  const handleReschedule = () => {
    confirmDialog(modal, {
      title: t('RESCHEDULE_CONFIRM_TITLE'),
      content: t('RESCHEDULE_POPUP_TEXT'),
      okText: t('OK_TEXT'),
      cancelText: t('CANCEL'),
      onOk() {
        const stageName = interview?.current_stage?.stage_name;
        if (!stageName) return;

        const search = new URLSearchParams(history.location.search);

        const filter = search.get('filter');

        search.set(INTERVIEW_ID_PARAM, interview?.id);
        search.set(STAGE_PARAM, stageName);
        search.set(SHOW_DATE_PROPOSE_PARAM, 'true');
        search.set(RESCHEDULE_PARAM, '1');

        const query = search.toString();

        if (filter) {
          history.push(CANDIDATES + '?' + query);
        } else {
          history.push(CANDIDATES + '?filter=in-process&' + query);
        }
      },
    });
  };
  return (
    <Button
      color="primary"
      variant="outlined"
      size="small"
      icon={<RetweetOutlined />}
      onClick={handleReschedule}
    >
      {t('RESCHEDULE_BUTTON_TEXT')}
    </Button>
  );
};

export default RescheduleDate;
